import { combineReducers } from "redux";
import userReducer from './userReducer';
import roomTypeReducer from './roomTypeReducer';
import authReducer from './authReducer';
import propertyReducer from './propertyReducer';
import uploadReducer from './uploadReducer';
import bannerReducer from './bannerReducer';
import tourReducer from './tourReducer';
import supplierReducer from './supplierReducer';
import orderReducer from './orderReducer';
import customerReducer from './customerReducer';
import groupReducer from './groupReducer';
import groupCategoryReducer from './groupCategoryReducer';
import productReducer from './productReducer';
import voucherReducer from './voucherReducer';
import roleReducer from './roleReducer';
import hotelReducer from './hotelReducer';
import generalReducer from './generalReducer';
import locationReducer from './locationReducer';
import customPriceReducer from './customPriceReducer';
import popularPlaceReducer from './popularPlaceReducer';
import categoryReducer from './categoryReducer';
import pageReducer from './pageReducer';
import postReducer from './postReducer';
import ratingReducer from './ratingReducer';
import reportReducer from './reportReducer';
import settingReducer from './settingReducer';
import ticketReducer from './ticketReducer';
import siteInfoReducer from './siteInfoReducer';
import agentReducer from './agentReducer';
import emailTemplateReducer from './emailTemplateReducer';
import airportReducer from './airportReducer';
import fareRuleReducer from './fareRuleReducer';
import baggageReducer from './baggageReducer';
import vinWonderReducer from './vinWonderReducer';
import vinWonderTicketReducer from './vinWonderTicketReducer';
import vinWonderPriceReducer from './vinWonderPriceReducer';
import tourTicketReducer from './tourTicketReducer';
import tourPropertyReducer from './tourPropertyReducer';
import rateReducer from './rateReducer';
import amenityReducer from './amenityReducer';
import couponReducer from './couponReducer';
import tagGroupDetailReducer from './tagGroupDetailReducer';
import tagGroupReducer from './tagGroupReducer';
import promotionReducer from './promotionReducer';
import campaignReducer from './campaignReducer';
import objectTypeReducer from './objectTypeReducer';
import redirectLinkReducer from './redirectLinkReducer';
import ticketSoldReducer from './ticketSoldReducer';
import supplierCategoryReducer from './supplierCategoryReducer';
import rateCodeReducer from './rateCodeReducer';
import configPHSReducer from './configPHSReducer';
import payAtHotelReducer from './payAtHotelReducer';
import markupBundleReducer from './markupBundleReducer';
import cashFlowReducer from './cashFlowReducer';
import recommendationReducer from './recommendationReducer'
import inventoryReducer from './inventoryReducer'
import pointChangeHistoryReducer from "./pointChangeHistoryReducer";
import bookablePackageRateReducer from "./bookablePackageRateReducer";
import packageRateReducer from "./packageRateReducer";
import bundleReportReducer from "./bundleReportReducer";
import appUIReducer from "./appUIReducer";
import homestayReducer from "./homestayReducer";
import homestayRoomTypeReducer from "./homestayRoomTypeReducer.js";
import homestayRateReducer from "./homestayRateReducer";
import vinwonderTagGroupReducer from "./vinwonderTagGroupReducer";
import golfReducer from "./golfReducer";
import autoTranslateReducer from "./autoTranslateReducer";
import fnbReducer from "./fnbReducer";
import cacheRedisReducer from "./cacheReducer";

export default combineReducers({
    fnbReducer,
    roomTypeReducer,
    homestayRoomTypeReducer,
    userReducer,
    authReducer,
    propertyReducer,
    uploadReducer,
    bannerReducer,
    tourReducer,
    supplierReducer,
    orderReducer,
    customerReducer,
    groupReducer,
    groupCategoryReducer,
    productReducer,
    voucherReducer,
    roleReducer,
    hotelReducer,
    homestayReducer,
    homestayRateReducer,
    generalReducer,
    locationReducer,
    customPriceReducer,
    popularPlaceReducer,
    categoryReducer,
    pageReducer,
    postReducer,
    ratingReducer,
    reportReducer,
    settingReducer,
    ticketReducer,
    siteInfoReducer,
    agentReducer,
    emailTemplateReducer,
    airportReducer,
    fareRuleReducer,
    baggageReducer,
    vinWonderReducer,
    vinWonderTicketReducer,
    vinWonderPriceReducer,
    tourTicketReducer,
    tourPropertyReducer,
    rateReducer,
    amenityReducer,
    couponReducer,
    tagGroupDetailReducer,
    tagGroupReducer,
    promotionReducer,
    campaignReducer,
    objectTypeReducer,
    ticketSoldReducer,
    rateCodeReducer,
    redirectLinkReducer,
    supplierCategoryReducer,
    configPHSReducer,
    payAtHotelReducer,
    markupBundleReducer,
    cashFlowReducer,
    recommendationReducer,
    inventoryReducer,
    pointChangeHistoryReducer,
    bookablePackageRateReducer,
    packageRateReducer,
    bundleReportReducer,
    appUIReducer,
    vinwonderTagGroupReducer,
    golfReducer,
    autoTranslateReducer,
    cacheRedisReducer
});
